import React, { useState, useMemo } from 'react';
import { Box, Typography, Stack, Paper } from '@mui/material';
import ITagDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import Search from '../Search/Search';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

interface Group {
  id: Guid;
  name: string;
  color: string;
  tags: ITagDetail[];
}

interface Props {
  title: string;
  groups: Group[];
  onTagClick: (tag: ITagDetail) => void;
  iconClass: string;
  backgroundColor: string;
}

const Panel = ({
  title,
  groups,
  onTagClick,
  iconClass,
  backgroundColor
}: Props) => {
  const [searchValue, setSearchValue] = useState('');

  const filteredGroups = useMemo(() => {
    return groups.map((group) => ({
      ...group,
      tags: group.tags.filter((tag) =>
        tag.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    }));
  }, [groups, searchValue]);

  return (
    <Paper elevation={0} sx={{ flex: 1, pt: 2 }}>
      <Typography fontSize={12}>{title}</Typography>
      <Search
        placeholder={'Search'}
        value={searchValue}
        onValueChange={setSearchValue}
      />

      <Box sx={{ backgroundColor, padding: '20px' }}>
        <Box
          sx={{
            maxHeight: 200,
            minHeight: 200,
            minWidth: 200,
            overflowY: 'scroll',
            overflowX: 'none',
            padding: '10px'
          }}
        >
          {filteredGroups.map((group) =>
            group.tags.length > 0 ? (
              <Box key={group.name} mb={2}>
                <Chip
                  key={group.id}
                  id={group.id}
                  name={group.name}
                  color={group.color}
                />
                <Stack mt={1} ml={2} spacing={1}>
                  {group.tags.map((tag) => (
                    <Box
                      key={tag.id}
                      display="flex"
                      alignItems="center"
                      gap={1}
                    >
                      <Typography sx={{ minWidth: 125 }}>{tag.name}</Typography>
                      <i
                        className={iconClass}
                        style={{ cursor: 'pointer' }}
                        onClick={() => onTagClick(tag)}
                      />
                    </Box>
                  ))}
                </Stack>
              </Box>
            ) : null
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default Panel;
